<div fxFill fxLayout="column">
        <h1>Users</h1>
        <div>
            <mat-table #table [dataSource]="userService.users">
    
                <!-- name -->
                <ng-container matColumnDef="name">
                    <mat-header-cell *matHeaderCellDef> Name </mat-header-cell>
                    <mat-cell [attr.title]="item.name" *matCellDef="let item"> <span title="{{item.name}}" class="user-{{item.role}}">{{item.abbreviation}}</span> {{item.name}} </mat-cell>
                </ng-container>
    
                <!-- role -->
                <ng-container matColumnDef="role">
                    <mat-header-cell *matHeaderCellDef> Role </mat-header-cell>
                    <mat-cell *matCellDef="let item">
                         {{item.role | titlecase}} 
                    </mat-cell>
                </ng-container>
    
                <!-- activeCount -->
                <ng-container matColumnDef="activeCount">
                    <mat-header-cell *matHeaderCellDef> Assignments </mat-header-cell>
                    <mat-cell *matCellDef="let item"> {{item.activeCount}} </mat-cell>
                </ng-container>
    
                <!-- overdueCount -->
                <ng-container matColumnDef="overdueCount">
                    <mat-header-cell *matHeaderCellDef> Overdue </mat-header-cell>
                    <mat-cell *matCellDef="let item"> {{item.overdueCount}} </mat-cell>
                </ng-container>
    
                <!-- actions -->
                <ng-container matColumnDef="actions">
                    <mat-header-cell *matHeaderCellDef>Actions</mat-header-cell>
                    <mat-cell *matCellDef="let item"> 
                        <a 
                            class="button"
                            [routerLink]="['/assignments']" 
                            [queryParams]="{user: item.id}" 
                            routerLinkActive="active">
                                Assignments
                        </a> 
                    </mat-cell>
                </ng-container>

                <!-- new -->
                <ng-container matColumnDef="new">
                    <mat-header-cell *matHeaderCellDef>  </mat-header-cell>
                    <mat-cell *matCellDef="let item"> 
                        <a 
                            class="button"
                            [routerLink]="['/users/profile', item.id]"
                            routerLinkActive="active"
                            >
                                Profile
                        </a> 
                    </mat-cell>
                </ng-container>
    
                <mat-header-row *matHeaderRowDef="columns"></mat-header-row>
                <mat-row *matRowDef="let row; columns: columns"></mat-row>
            </mat-table>
        </div>
    </div>